import { loggerProvider } from '@/telemetry-sdk/setup/csr';
import { getExtendedAttributes } from '@/telemetry-sdk';
import { SeverityNumber } from '@opentelemetry/api-logs';
import { diag } from '@opentelemetry/api';

const otelLogging = diag.createComponentLogger({
  namespace: '✨ @telemetry-sdk/utils/otel-logging',
});

export function emitOtelLog(message: string, pageKey: string, userId: string, traceId?: string) {
  if (!loggerProvider) {
    return;
  }
  try {
    let attributes = {
      ...getExtendedAttributes(pageKey, userId),
      'ld.trace.id': traceId,
      pageKey: pageKey,
    };

    loggerProvider.getLogger('default').emit({
      severityNumber: SeverityNumber.ERROR,
      severityText: 'ERROR',
      body: message,
      attributes: attributes,
      timestamp: Date.now(),
    });
  } catch (loggingError) {
    otelLogging.error('Failed to log error to OpenTelemetry:', loggingError);
    otelLogging.error('Original error message:', message);
  }
}
